import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import DocumentEditor from './components/DocumentEditor';
import ClientEditSidebar, { ACTIVE_CLIENT_SIDEBAR_TAB_NAMES } from '../clientedit/ClientEditSidebar';

function DocumentEditPage() {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.documents} />
                <Grid className="pageContent">
                    <DocumentEditor clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default DocumentEditPage;
